import React from 'react'

import Link from 'antd/es/typography/Link'
import { twMerge } from 'tailwind-merge'

type Props = {
  onClick: () => void
  cta: string
  highlightMode: 'hover' | 'always'
  children: React.ReactNode
}
const LinkArea = ({ children, onClick, cta, highlightMode }: Props) => {
  return (
    <Link className="w-full" onClick={onClick}>
      <div
        className={twMerge([
          'p-1',
          'group relative rounded-md border !text-black',
          highlightMode === 'hover'
            ? 'border-transparent hover:border-solid hover:border-yellow-300'
            : 'border-solid border-yellow-300',
        ])}
      >
        {children}
        <div className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full transform opacity-0 transition-opacity duration-200 group-hover:opacity-100">
          <div className="rounded border border-yellow-300 bg-yellow-50 px-2 py-1 text-sm whitespace-nowrap text-yellow-800 shadow-lg">
            {cta}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-full transform">
              <div className="h-0 w-0 border-r-4 border-b-4 border-l-4 border-transparent border-b-yellow-300"></div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default React.memo(LinkArea)
